import { useDispatch } from "react-redux";

// Actions
import { openDownloadMediaReportForm } from "../../../actions/media-report/MediaReportActions";

// Constants
import { FormDataTargets } from "../../../constants/GeneralConstants";

// Components
import Spinner from "../../../components/spinner/Spinner";

// Media Report Download
export default function MediaReportDownload({ loading = false }) {
  const dispatch = useDispatch();

  // loading
  if (loading) {
    return <Spinner />;
  }

  return (
    <p
      className="text-primary cursor-pointer my-2"
      data-toggle="modal"
      data-target={`#${FormDataTargets.downloadReportsForm}`}
      onClick={() => dispatch(openDownloadMediaReportForm())}
      data-html2canvas-ignore="true"
    >
      Download Media PDF Report
    </p>
  );
}
